import { render } from "./tab-rtc-truck.vue?vue&type=template&id=4b57bf9d&ts=true"
import script from "./tab-rtc-truck.vue?vue&type=script&lang=ts"
export * from "./tab-rtc-truck.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__